export const PAYMENT_PLANS_TABS = {
  plans: 'plans',
  oneOff: 'oneOff',
};

export const PLAN_FREQUENCIES = ['weekly', 'bi_weekly', 'monthly'];

export const TAB_FREQUENCIES = {
  [PAYMENT_PLANS_TABS.plans]: PLAN_FREQUENCIES,
  [PAYMENT_PLANS_TABS.oneOff]: ['one_time'],
};

export const PLAN_STATUSES = ['active', 'paused', 'completed', 'cancelled'];

export const STATUS_PILL_VARIANTS = {
  active: 'success',
  paused: 'alert',
  completed: 'neutral',
  cancelled: 'error',
};

export const NEXT_PAYMENT_RANGES = {
  any: 'any',
  next7Days: 'next7Days',
  next4Weeks: 'next4Weeks',
};

export const NEXT_PAYMENT_RANGE_DAYS = {
  [NEXT_PAYMENT_RANGES.next7Days]: 7,
  [NEXT_PAYMENT_RANGES.next4Weeks]: 28,
};

export const PLAN_FILTER_KEYS = {
  status: 'status',
  frequency: 'frequency',
  nextPayment: 'nextPayment',
};

export const getInitialFilters = () => ({
  [PLAN_FILTER_KEYS.status]: [],
  [PLAN_FILTER_KEYS.frequency]: [],
  [PLAN_FILTER_KEYS.nextPayment]: NEXT_PAYMENT_RANGES.any,
});

export const SUMMARY_TILES = {
  collected: 'collected',
  active: 'active',
  expected: 'expected',
  needsReview: 'needsReview',
};

export const TILE_FILTERS = {
  [SUMMARY_TILES.active]: { key: PLAN_FILTER_KEYS.status, value: ['active'] },
  [SUMMARY_TILES.expected]: { key: PLAN_FILTER_KEYS.nextPayment, value: NEXT_PAYMENT_RANGES.next4Weeks },
  [SUMMARY_TILES.needsReview]: { key: PLAN_FILTER_KEYS.status, value: ['paused'] },
};

export const PER_PAGE_OPTIONS = [10, 25, 50, 100];
export const DEFAULT_PER_PAGE = 25;

export const SORT_FIELDS = {
  client: 'client_name',
  nextPayment: 'next_payment_date',
  amount: 'amount',
  paymentDate: 'start_date',
};

export const TAB_DEFAULT_SORT = {
  [PAYMENT_PLANS_TABS.plans]: { field: SORT_FIELDS.nextPayment, direction: 'asc' },
  [PAYMENT_PLANS_TABS.oneOff]: {
    field: SORT_FIELDS.nextPayment,
    direction: 'asc',
    then: `${SORT_FIELDS.paymentDate}:desc`,
    column: SORT_FIELDS.paymentDate,
  },
};

const CLIENT_COLUMN = { value: 'client_name', label: 'client', sortField: SORT_FIELDS.client, minWidth: 140, maxWidth: 200 };
const LINKED_TO_COLUMN = { value: 'paymentRequest', label: 'linked_to', minWidth: 140, maxWidth: 200 };
const STATUS_COLUMN = { value: 'status', label: 'status', minWidth: 120 };
const AMOUNT_COLUMN = { value: 'amount', sortField: SORT_FIELDS.amount, minWidth: 120 };

export const TAB_COLUMNS = {
  [PAYMENT_PLANS_TABS.plans]: [
    CLIENT_COLUMN,
    { value: 'name', label: 'plan', minWidth: 160, maxWidth: 240 },
    LINKED_TO_COLUMN,
    { value: 'progress', label: 'frequency_and_progress', minWidth: 200 },
    { value: 'nextPayment', label: 'next_payment', sortField: SORT_FIELDS.nextPayment, minWidth: 140 },
    STATUS_COLUMN,
    { ...AMOUNT_COLUMN, label: 'per_charge' },
  ],
  [PAYMENT_PLANS_TABS.oneOff]: [
    CLIENT_COLUMN,
    { value: 'name', label: 'payment', minWidth: 160, maxWidth: 240 },
    LINKED_TO_COLUMN,
    { value: 'paymentDate', label: 'payment_date', sortField: SORT_FIELDS.paymentDate, minWidth: 140 },
    STATUS_COLUMN,
    { ...AMOUNT_COLUMN, label: 'amount' },
  ],
};
